let config = {
  preUrl: 'https://wx.aixyt.com',
  // socket: 'http://iosocket.aixyt.com/',
  socket: 'http://exportsocket.aixyt.com/',
  uploadPreUrl: 'http://wx.aixyt.com',
  xytPreUrl: 'http://live.aixyt.com',
  // 公钥
  pubKey: '-----BEGIN PUBLIC KEY-----\n' +
    'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAO0PPEWQv4PFa7UNm4v6MGhFKUTnXegr\n' +
    'd1mvIpRX0p7qNDTIi85nY929T/14EKr0xzS/ZwtG22cnp8XhapV55qkCAwEAAQ==\n' +
    '-----END PUBLIC KEY-----',
  systemAuth: 'auth',
  boxQrcodePrevUrl: "https://wx.aixyt.com/qrcode/box/",
  mpWorksiteQrcodePrevUrl: "https://wx.aixyt.com/qrcode/ws/",
  mpShopQrcodePrevUrl: "https://wx.aixyt.com/qrcode/shop/"
}

export default config



// WEBPACK FOOTER //
// ./src/config/config.js